import { CONFIG } from "~/config";

// o kolik minut drive zadat o cookies 10[m]
const TIMEOUT_DIFF = 1000 * 60 * 10;
let lastExpiration = CONFIG.cookiesExpiration;

async function getCookiesExpiration() {
	try {
		const request = await fetch(`/refreshCookies`);
		const json: { expiration: number; msg: string } = await request.json();

		if (request.status >= 200 && request.status < 300) {
			return json.expiration;
		}
	} catch (exc) {
		//
	}

	return 0;
}

function cookieRefresher() {
	const curTime = Date.now();
	// z BE chodi sekundy
	const timeout = (lastExpiration * 1000) - TIMEOUT_DIFF - curTime;

	setTimeout(async () => {
		const cookiesExpiration = await getCookiesExpiration();

		if (cookiesExpiration > 0) {
			lastExpiration = cookiesExpiration;

			// zavolame znova
			cookieRefresher();
		}
	}, timeout);
}

export function startCookieRefresher() {
	if (lastExpiration > 0) {
		cookieRefresher();
	}
}
